import settings from '../utils/settings';

export const ENPHASE_URL = 'https://enphase.com';
export const PLATFORM_VIDEO_LINK =
  'https://enphaseenergy.wistia.com/medias/c09j6kms57';
export const DIGITAL_PLATFORM_LINK =
  'https://enphaseenergy.wistia.com/medias/c09j6kms57';
export const SOLARGRAF_REGISTER_LINK = 'https://www.solargraf.com/register/';
export const SOLARGRAF_DRAW_DESIGN_TUTORIAL =
  'https://www.youtube.com/embed/mJZF2LROdZs?rel=0&playlist=mJZF2LROdZs&loop=1';
export const FLEET_DASHBOARD_URL = '/manager/dashboard/systems';
export const GENERATOR_TOKENS_URL = '/manager/dashboard/generator-tokens';
export const DATA_PLAN_EXENSION_URL = '/manager/dashboard/data-plan-extension';
export const COMMON_IFRAME_ID = 'common-iframe';
export const FEATURES = {
  EIN_DASHBOARD: 'EIN_DASHBOARD',
  EIN_ADMIN: 'EIN_ADMIN',
  PERMIT_ENABLED: 'PERMIT_ENABLED',
  BOM_CALCULATOR: 'BOM_Calculator',
  LEAD_OPT_IN: '21noveinprofile2019',
  EIN_OPT_IN: 'EIN_OPT_IN',
  LRE_ENABLED: 'LRE_ENABLED',
  INCENTIVE_PROGRAM: 'INCENTIVE_PROGRAM',
  EIN_MERCHANDISE: 'EIN_MERCHANDISE',
  PERMIT_ADMIN: 'PERMIT_ADMIN',
  SGIP_ADMIN: 'SGIP_ADMIN',
  SOLARGRAF_ENABLED: 'SOLARGRAF_ENABLED',
  SOLARGRAF_PLATFORM_INSTALLER: 'Solargraf_Platform_Installer',
  DRS_ENABLED_COMPANY: 'DRS_ENABLED_COMPANY',
  DRS_ENABLED_USER: 'DRS_ENABLED_USER',
  ACTIVATION_WEB_FEATURE: 'activation_web_feature',
  ENABLE_NEW_ACTIVATION_ONLY: 'enable_new_activation_only',
  LEAD_PURCHASE_STORE: 'Lead_Purchase_Store',
  COMMERCIAL_SHORTCUT_PAGE: 'Commercial_Shortcut_Page',
  TRAINING_DASHBOARD_FEATURE: 'training_dashboard',
  PORTUGUESE_TRANSLATION: 'pt_translations',
  POLISH_TRANSLATION: 'pl_translations',
  AUTHORIZED_SUBCONTRACTOR: 'authorized_subcontractor',
  THREE_G_MODEM_REPLACEMENT: '3g_modem_replacement',
  RMA_DASHBOARD: 'rma_dashboard',
  GENERATOR_TOKENS: 'generator_tokens',
  ENLIGHTEN_VERSION_FOOTER: 'enlighten_version_footer',
  PRONTO_INSTALLER: 'installer_pronto_integration',
  GRID_PROFILE_SELF_INSTALLER_FEATURE_ID: 'grid_profile_self_installer',
  LEADS_QUICKACCESS: 'Leads_QuickAccess',
  CELLMODEM_DATA_PLAN_EXTENSION: 'CellModem_Data_Plan_Extension',
  CELLMODEM_DATA_PLAN_EXTENSION_STORE: 'CellModem_Data_Plan_Extension_Store',
  ENLA_ENLM_SYSTEM_TABLE_REFACTORING: 'enla_enlm_system_table_refactoring',
  SAVINGS_WIDGET_FLEET_DASHBOARD: 'savings_widget_fleet_dashboard',
  FLEET_SWITCH_TO_CLASSIC_VIEW: 'fleet_switch_to_classic_view'
};

export const MAX_PREFERENCES_COUNT = 7;
export const PREFERENCE_AB_GATE_FEATURE_ID = '47c84d5ac43f95a7';
export const PREFERENCE_MOBILE_NUMBER_UPDATE_FLAG = 'update-mobile-number';

const SERVICE_MANAGER_URL = {
  production:
    'https://service.enphaseenergy.com/?utm_source=enlighten-manager-home&utm_medium=referral',
  qa2: 'https://service-qa2.enphaseenergy.com/',
  rel: 'https://service-rel.qa-enphaseenergy.com/',
  integration: 'https://service-manager-intg.qa-enphaseenergy.com/',
  qa4: 'https://service-manager-dev.qa-enphaseenergy.com/'
};

const SERVICE_MANAGER_BASE_URL = {
  production: 'https://service.enphaseenergy.com',
  qa2: 'https://service-qa2.enphaseenergy.com',
  rel: 'https://service-rel.qa-enphaseenergy.com',
  integration: 'https://service-manager-intg.qa-enphaseenergy.com',
  qa4: 'https://service-manager-dev.qa-enphaseenergy.com'
};

const US = {
  support: 'https://enphase.com/en-us/support/contact-support',
  enlightenHelp:
    'https://enphase.com/en-us/support/solar-professionals/software?modal-content=support-regions&m=mgr',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-us/'
      : 'https://store.enphase.com/storefront/en-us/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-us/sales/order/history/'
      : 'https://store.enphase.com/storefront/en-us/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/en-us/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/download/ceo-letter-partners',
  termsCondition: 'https://enphase.com/enphase-installer-network-terms',
  companyLearnMore: 'https://enphaseenergy.wistia.com/medias/04o04lz76p',
  serviceAreaLearnMore: 'https://enphaseenergy.wistia.com/medias/q5ovu4c4sm',
  leadPreferenceLearnMore: 'https://enphaseenergy.wistia.com/medias/ebpp09y4zr',
  buymore:
    'https://businesscenter.enphase.com/content/loginOrRegister?loggedOut=true',
  privacy: 'https://enphase.com/en-us/legal/privacy-policy',
  terms: 'https://enphase.com/en-us/legal/terms-of-service',
  currencySymbol: '$',
  serviceManager: SERVICE_MANAGER_URL[window.build_environment],
  serviceManagerBaseUrl: SERVICE_MANAGER_BASE_URL[window.build_environment],
  leads:
    window.build_environment === 'production'
      ? 'https://start.enphase.com/leads-program-signup/'
      : 'https://dev.understandsolarpower.com/leads-program-signup/',
  training: 'https://enphase.com/installers/training-and-certifications',
  documentation: 'https://enphase.com/installers/resources/documentation',
  criticalUpdates: 'https://enphase.com/installers/updates'
};

const AU = {
  support: 'https://enphase.com/en-au/support/contact',
  enlightenHelp:
    'https://enphase.com/en-au/support/solar-professionals/software',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-au/'
      : 'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-au/sales/order/history/'
      : 'https://store.enphase.com/storefront/en-au/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/en-au/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/en-au/download/ceo-letter-partners-au',
  termsCondition: 'https://enphase.com/en-au/enphase-installer-network-terms',
  companyLearnMore: 'https://enphaseenergy.wistia.com/medias/wqj4fe2b1x',
  serviceAreaLearnMore: 'https://enphaseenergy.wistia.com/medias/wacwbirf33',
  leadPreferenceLearnMore: 'https://enphaseenergy.wistia.com/medias/lb7dqj2h9b',
  buymore:
    'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  currencySymbol: 'A$',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4'
};

const DE = {
  support: 'https://www4.enphase.com/de-de/support/kontaktieren',
  enlightenHelp:
    'https://enphase.com/de-de/support/solarprofis/enlighten-manager?m=mgr',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/de-de/'
      : 'https://store.enphase.com/storefront/de-de/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/de-de/sales/order/history/'
      : 'https://store.enphase.com/storefront/de-de/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/de-de/installers/enphase-installer-network',
  messageFromCeo: 'https://enphase.com/de-de/download/letter-ceo-de',
  termsCondition: 'https://enphase.com/de-de/enphase-installer-network-terms',
  buymore:
    'https://store.enphase.com/storefront/de-de/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/de-de/datenschutzrichtlinie',
  terms: 'https://enphase.com/de-de/legal/service-und-nutzungsbestimmungen',
  currencySymbol: '€',
  training: 'https://enphase.com/de-de/installers/training-and-certifications',
  documentation: 'https://enphase.com/de-de/installers/resources/documentation',
  criticalUpdates: 'https://enphase.com/de-de/installers/updates'
};

const NL = {
  support: 'https://enphase.com/nl-nl/support/contact',
  enlightenHelp:
    'https://enphase.com/nl-nl/support/zonne-energieprofessionals/enlighten-manager?m=mgr',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/nl-nl/'
      : 'https://store.enphase.com/storefront/nl-nl/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/nl-nl/sales/order/history/'
      : 'https://store.enphase.com/storefront/nl-nl/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/nl-nl/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/nl-nl/download/letter-ceo-nl',
  termsCondition:
    'https://www4.enphase.com/nl-nl/legal/enphase-installer-network-terms-conditions',
  buymore:
    'https://store.enphase.com/storefront/nl-nl/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/nl-nl/legal/privacybeleid',
  terms: 'https://enphase.com/nl-nl/legal/algemene-voorwaarden',
  currencySymbol: '€'
};

const NC = {
  support: 'https://enphase.com/en-au/support/contact',
  enlightenHelp:
    'https://enphase.com/en-au/support/solar-professionals/software',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-au/'
      : 'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-au/sales/order/history/'
      : 'https://store.enphase.com/storefront/en-au/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/en-au/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/en-au/download/ceo-letter-partners-au',
  termsCondition: 'https://enphase.com/en-au/enphase-installer-network-terms',
  companyLearnMore: 'https://enphaseenergy.wistia.com/medias/wqj4fe2b1x',
  serviceAreaLearnMore: 'https://enphaseenergy.wistia.com/medias/wacwbirf33',
  leadPreferenceLearnMore: 'https://enphaseenergy.wistia.com/medias/lb7dqj2h9b',
  buymore:
    'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  currencySymbol: '$',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4'
};
const NZ = {
  support: 'https://enphase.com/en-au/support/contact',
  enlightenHelp:
    'https://enphase.com/en-au/support/solar-professionals/software',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-au/'
      : 'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/en-au/sales/order/history/'
      : 'https://store.enphase.com/storefront/en-au/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/en-au/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/en-au/download/ceo-letter-partners-au',
  termsCondition: 'https://enphase.com/en-au/enphase-installer-network-terms',
  companyLearnMore: 'https://enphaseenergy.wistia.com/medias/wqj4fe2b1x',
  serviceAreaLearnMore: 'https://enphaseenergy.wistia.com/medias/wacwbirf33',
  leadPreferenceLearnMore: 'https://enphaseenergy.wistia.com/medias/lb7dqj2h9b',
  buymore:
    'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  currencySymbol: 'NZ $',
  productWarrantyExtension:
    'https://encare.enphase.com/?upgradeProgramType=4&locale=en-nz'
};
const BE = {
  support: 'https://enphase.com/nl-nl/support/contact',
  enlightenHelp:
    'https://enphase.com/nl-nl/support/zonne-energieprofessionals/enlighten-manager?m=mgr',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/nl-be/'
      : 'https://store.enphase.com/storefront/nl-be/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/nl-be/sales/order/history/'
      : 'https://store.enphase.com/storefront/nl-be/sales/order/history/',
  aboutInstaller:
    'https://enphase.com/nl-nl/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/nl-nl/download/letter-ceo-nl',
  termsCondition:
    'https://www4.enphase.com/nl-nl/legal/enphase-installer-network-terms-conditions',
  buymore:
    'https://store.enphase.com/storefront/nl-be/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/nl-nl/legal/privacybeleid',
  terms: 'https://enphase.com/nl-nl/legal/algemene-voorwaarden',
  currencySymbol: '€'
};

const IN = {
  support: 'https://enphase.com/en-in/support/contact-support',
  aboutInstaller:
    'https://enphase.com/en-in/installers/about-installer-network',
  messageFromCeo:
    'https://www4.enphase.com/sites/default/files/CEO-Letter-to-Partners.pdf?2123=',
  termsCondition: 'https://enphase.com/enphase-installer-network-terms',
  currencySymbol: '₹',
  productWarrantyExtension:
    'https://encare.enphase.com/?upgradeProgramType=4&locale=en-in'
};

const MX = {
  support: 'https://enphase.com/es-lac/contact-support-es-lac',
  enlightenHelp:
    'https://enphase.com/es-lac/soporte/profesionales/enlighten-manager?m=mgr',
  aboutInstaller:
    'https://enphase.com/es-lac/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/es-mx/download/letter-ceomx',
  termsCondition: 'https://enphase.com/es-mx/enphase-installer-network-terms',
  privacy:
    'https://enphase.com/es-lac/condiciones-legales/politica-de-privacidad',
  terms:
    'https://enphase.com/es-lac/condiciones-legales/terminos-y-condiciones',
  currencySymbol: '$',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4'
};

const BR = {
  support: 'https://enphase.com/pt-br/support/contact',
  privacy: 'https://enphase.com/pt-br/legal/privacy-policy',
  terms: 'https://enphase.com/pt-br/legal/terms-of-service',
  messageFromCeo:
    'https://dev-d9.enphase.com/pt-pt/download/ceo-letter-partners-br',
  termsCondition:
    'https://dev-d9.enphase.com/pt-br/legal/installer-network-terms-conditions',
  aboutInstaller: 'https://www.enphase.com/pt-br/installers/resources/ein',
  currencySymbol: 'R$'
};

const IT = {
  support: 'https://enphase.com/it-it/support/contact',
  enlightenHelp: 'https://www2.enphase.com/enlighten-help/it/?m=mgr',
  privacy: 'https://enphase.com/it-it/note-legali/informativa-sulla-privacy',
  terms: 'https://enphase.com/it-it/note-legali/condizioni-del-servizio',
  currencySymbol: '€'
};

const FR = {
  support: 'https://enphase.com/fr-fr/nous-contacter',
  enlightenHelp:
    'https://enphase.com/fr-fr/support/professionnels/enlighten-manager?m=mgr',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/fr-fr/'
      : 'https://store.enphase.com/storefront/fr-fr/?utm_source=enlighten-manager-home&utm_medium=referral',
  aboutInstaller:
    'https://www4.enphase.com/fr-fr/installers/about-installer-network',
  messageFromCeo: 'https://enphase.com/fr-fr/download/letter-ceo-fr',
  termsCondition:
    'https://www4.enphase.com/fr-fr/legal/enphase-installer-network-terms-conditions',
  buymore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/fr-fr/'
      : 'https://store.enphase.com/storefront/fr-fr/',
  privacy: 'https://enphase.com/fr-fr/juridique/politique-de-confidentialite',
  terms: 'https://enphase.com/fr-fr/juridique/conditions-generales',
  currencySymbol: '€'
};

const ES = {
  support: 'https://enphase.com/es-es/empresa/contacto',
  enlightenHelp: 'https://enphase.com/es-es/soporte/profesionales/software',
  enphaseStore:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/es-es/'
      : 'https://store.enphase.com/storefront/es-es/?utm_source=enlighten-manager-home&utm_medium=referral',
  enphaseStoreOrder:
    window.build_environment === 'qa2'
      ? 'https://store-qa2.enphase.com/storefront/es-es/sales/order/history/'
      : 'https://store.enphase.com/storefront/es-es/sales/order/history/',
  aboutInstaller: 'https://enphase.com/es-es/installers/resources/ein',
  messageFromCeo: 'https://enphase.com/es-es/download/ceo-letter-spain',
  termsCondition: 'https://enphase.com/es-es/enphase-installer-network-terms',
  buymore:
    'https://store.enphase.com/storefront/es-es/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy:
    'https://enphase.com/es-es/condiciones-legales/politica-de-privacidad',
  terms: 'https://enphase.com/es-es/condiciones-legales/terminos-y-condiciones',
  currencySymbol: '€'
};

export default { US, AU, DE, NL, BE, IN, MX, BR, NZ, NC, IT, FR, ES };
